import { Navigate, Outlet, useLocation } from 'react-router'
import { Stack, Text } from '@/design-system'
import { PassMark } from '@/app/Logo'
import { useAuth } from './auth-context'

export function RequireAuth() {
  const { status } = useAuth()
  const location = useLocation()

  if (status === 'checking') {
    return (
      <Stack align="center" justify="center" gap={4} style={{ minHeight: '100dvh' }}>
        <PassMark size={40} />
        <Text variant="caption" tone="secondary">
          Checking your session…
        </Text>
      </Stack>
    )
  }

  if (status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return <Outlet />
}

/** Keeps a signed-in person out of the login and sign-up screens. */
export function RedirectIfAuthenticated() {
  const { status } = useAuth()
  if (status === 'authenticated') return <Navigate to="/" replace />
  return <Outlet />
}
